module.exports = __webpack_public_path__ + "img/login-form.3ea4179f.png";